import React, { useEffect, useState } from "react";
import EmployeeAPIs from "../../../../../MasonyFixingsAPIs/EmployeeAPIs/EmployeeAPIs";
import {  FaSave } from "react-icons/fa";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdDelete, MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ApiResponseHandler from "../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { Form } from "react-bootstrap";
import { useToast } from "../../../../../Contexts/ToastContext";

export default function ViewEmployee({employeeID, companyID, getEmployees}){

    const {addToast} = useToast();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);

    const [employeeData, setEmployeeData] = useState({});
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [employeeTypeID, setEmployeeTypeID] = useState('');

    const getEmployee = (employeeID) => {

        EmployeeAPIs.GetEmployee(employeeID)
        .then((response) => {
            if(response.status === 200){
                setEmployeeData(response.data);
                setFirstName(response.data.first_name);
                setLastName(response.data.last_name);
                setPhone(response.data.phone);
                setEmail(response.data.email ?? '');
                setEmployeeTypeID(response.data.employee_type_id);
                setLoading(false);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const updateEmployee = () => {

        setSending(true);
        const putJSON = {
            first_name: firstName,
            last_name: lastName,
            phone: phone,
            email: email,
            employee_type_id: employeeTypeID
        }

        if(
            firstName !== '' &&
            lastName !== '' &&
            employeeID !== ''
        ){
            EmployeeAPIs.PutEmployee(employeeID, putJSON)
            .then((response) => {
                if(response.status === 200){
                    setEditing(false);
                    getEmployees(companyID);
                    getEmployee(employeeID);
                    setSending(false);
                    addToast({ message: "Employee updated successfully!", variant: "success", autoHide: true });
                }
            })
            .catch((err) => {
                setSending(false);
                ApiResponseHandler(err.response, navigate);
            })
        }

    }

    const deleteEmployee = () => {
        setSending(true);
        EmployeeAPIs.DeleteEmployee(employeeID)
        .then((response) => {
            if(response.status === 200){
                getEmployees(companyID);
                setSending(false);
                addToast({ message: "Empoloyee deleted successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err);
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
    }

    const handleCancel = () => {
        setFirstName(employeeData.first_name);
        setLastName(employeeData.last_name);
        setPhone(employeeData.phone);
        setEmployeeTypeID(employeeData.employee_type_id);
        setEditing(false);
    }

    const handleDelete = () => {
        if(window.confirm('Are you sure you want to permanently delete ?')){
            deleteEmployee();
        }
    }

    useEffect(() => {
        getEmployee(employeeID);
    }, [employeeID]);

    if(loading){
        return(<div>Loading employee...</div>)
    }
    return(

        <div className="project-header">
            <div className="project-header-left">
                


                <div className={`project-meta`}>

                    {editing ? 
                        <div className="meta-item">
                                    <span className="label">First Name:</span>
                                    <Form.Control size='sm'  disabled={sending} className='editable-field' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                
                                </div>
                                
                            :

                        <div className="meta-item">
                            <span className="label">First Name:</span>
                            <span>{employeeData.first_name ? employeeData.first_name : 'Not set'}</span>
                        </div>
                    }

                    {editing ? 
                        <div className="meta-item">
                                    <span className="label">Last Name:</span>
                                    <Form.Control size='sm'  disabled={sending} className='editable-field' value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                
                                </div>
                                
                            :

                        <div className="meta-item">
                            <span className="label">Last Name:</span>
                            <span>{employeeData.last_name ? employeeData.last_name : 'Not set'}</span>
                        </div>
                    }

                    {editing ? 
                        <div className="meta-item">
                                    <span className="label">Email:</span>
                                    <Form.Control size='sm' type='email' disabled={sending} className='editable-field' value={email} onChange={(e) => setEmail(e.target.value)} />
                               
                                </div>
                                
                            :
    
                        <div className="meta-item">
                            <span className="label">Email:</span>
                            <span>{employeeData.email ? employeeData.email : 'Not set'}</span>
                        </div>
                        }

                    {editing ? 
                        <div className="meta-item">
                                    <span className="label">Phone:</span>
                                    <Form.Control size='sm'  disabled={sending} className='editable-field' value={phone} onChange={(e) => setPhone(e.target.value)} />
                                
                                </div>
                                
                            :

                        <div className="meta-item">
                            <span className="label">Phone:</span>
                            <span>{employeeData.phone ? employeeData.phone : 'Not set'}</span>
                        </div>
                    }

                        


                </div>

            </div>

            <div className={`project-header-actions`}>
                {editing ? (
                    <>
                        <button disabled={sending || firstName === ''} className="save-btn" onClick={() => updateEmployee()}>{sending ? 'Saving' : 'Save'}</button>
                        <button disabled={sending} className="cancel-btn" onClick={() => handleCancel()}>Cancel</button>
                    </>
                ) : (
                    <>
                        <button disabled={sending} className="edit-btn" onClick={() => setEditing(true)}>
                            <MdEdit /> Edit
                        </button>

                        <button disabled={sending} className="delete-btn" onClick={handleDelete}>
                            <MdDelete /> {sending ? 'Deleting...' : 'Delete'}
                        </button>
                    </>
                )}
            </div>

        </div>
        
        // <tr>
        //     <td>{edit ? <input value={firstName} onChange={(e) => setFirstName(e.target.value)} /> : firstName} </td> 
        //     <td>{edit ? <input value={lastName} onChange={(e) => setLastName(e.target.value)} /> : lastName} </td> 
        //     <td>{edit ? <input value={phone} onChange={(e) => setPhone(e.target.value)} /> : phone}</td> 
        //     <td>{edit ? <input value={email} onChange={(e) => setEmail(e.target.value)} /> : email}</td> 
        //     {edit ? 
        //         <>
        //             <td>
        //                 <button disabled={sending} onClick={() => updateEmployee()}><FaSave/></button> 
        //             </td>
        //             <td>
        //                 <button disabled={sending} onClick={() => handleCancel()}><MdCancel/></button>
        //             </td>
        //         </>
        //         :
        //         <>
        //             <td>
        //                 <button disabled={sending} onClick={() => handleDelete()}><MdDelete/></button> 
        //             </td>
        //             <td>
        //                 <button disabled={sending} onClick={() => setEdit(true)}><AiFillEdit/></button>
        //             </td>
        //         </>
                 
        //     }
    
        // </tr>
      
    )
    


}